

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface purchaseReturnDetailsParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;

}

export interface purchaseReturnDetails {
  [medicine: string]: any;
  id: any;


  returnId: string;

  productId: string;

  qty: Number;

  batchNum: string;

  expiryDate: string;

  costPrice: Number;

  unitsStrip: Number;

  mrpPerStrip: Number;

  freeStrips: Number;

  discountPer: Number;

  discountValue: Number;

  amount: Number;

  gstTotalPer: string;

  igstPer: Number;

  sgstPer: Number;

  cgstPer: Number;

  gstTotalValue: Number;

  igstValue: Number;

  cgstValue: Number;

  sgstValue: Number;

  gstPer: Number;

  taxableAmount: Number;

  payableAmount: Number;

  tenantId: string;

  branchId: string;

  sellPriceStrip: Number; 
  unitSellPrice: Number;
  
  parameters?: purchaseReturnDetailsParameter[];
  links?: any;
}

export abstract class purchaseReturnDetailsData {

  abstract list(url: string): Observable<purchaseReturnDetails[]>;
  abstract create(url: string, data: purchaseReturnDetails): Observable<any>;
  abstract update(url: string, data: purchaseReturnDetails): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
